import React, { useEffect, useState, useCallback, ChangeEvent } from "react";
import { Button, Card, MenuItem, useTheme } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "src/store/Store";
import { PageContainer, Breadcrumb } from "../common";
import Loading from "../common/Loading";
import { selectUserCompany } from "src/store/authSlice";
import { client } from "src/common/axiosClient";
import Modal from "../common/Modal";
import { useNavigate } from "react-router";
import moment from "moment";

export default function MaunalTheraistByReservationList({
  id,
  type,
  name,
}: any) {
  const navigate = useNavigate();
  const theme = useTheme();

  const borderColor = theme.palette.divider;

  const [isLoding, setLoding] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [activeButton, setActiveButton] = useState("today");

  useEffect(() => {
    getReservationList();
  }, []);
  useEffect(() => {
    getReservationList();
  }, [type]);

  const getReservationList = async () => {
    let to = moment().format("YYYY-MM-DD");
    let from = moment().format("YYYY-MM-DD");

    if (type === "week") {
      from = moment().subtract(7, "days").format("YYYY-MM-DD");
    } else if (type === "month") {
      from = moment().startOf("month").format("YYYY-MM-DD");
      to = moment().endOf("month").format("YYYY-MM-DD");
    }

    setData([]);
    const response = await client.get(
      `/admin/api/v1/reservation/MANUAL_THERAPIST/medical-staff/${id}/period?from=${from}&to=${to}`,
      {}
    );
    if (response.status === 200) {
      console.log(response);
      setData([...response.data.content]);
    } else {
      console.log(response);
    }
  };

  const getAge = (value: any) => {
    const birthDate = moment(value, "YYYY-MM-DD");

    // 현재 나이 계산
    const age = moment().diff(birthDate, "years");
    return age;
  };

  return (
    <>
      <div className="flex my-4 text-center items-center justify-center">
        <div className="text-lg mt-2 font-bold ">{name}</div>
        <div className="text-base font-semibold mt-3 ml-2">
          {" "}
          예약인원 {data.length}명
        </div>
      </div>
      <div className="border h-[190px] overflow-x-auto">
        {data.length > 0 ? (
          <table className="w-full text-sm text-left text-gray-500 ">
            <tbody>
              {data.map((item, index) => {
                //  {id:1, status:'대기', dayStatus:'경고', dDay:10, backgroundColor:'#D1T32'},
                return (
                  <tr
                    key={index}
                    className="bg-white border-b  hover:bg-gray-200 "
                  >
                    <td className="px-1 py-1">
                      {item.visitStatus === "FOLLOW_UP" ? (
                        <span className="bg-green-200 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                          재진
                        </span>
                      ) : (
                        <span className="bg-yellow-200 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                          초진
                        </span>
                      )}
                    </td>
                    <td className="px-1 py-1">
                      {item.patient?.name ? item.patient.name : "-"}(
                      {item.patient?.birthDate
                        ? getAge(item.patient.birthDate)
                        : ""}
                      )
                    </td>
                    <td className="px-1 py-1">
                      {item.reservedAt
                        ? moment(item.reservedAt).format("MM-DD HH:mm")
                        : "-"}
                    </td>
                    <td className="px-1 py-1">
                      {item.patient?.gender === "MALE" ? (
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                          남자
                        </span>
                      ) : (
                        <span className="bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded ">
                          여자
                        </span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div className="font-semibold">기간내의 예약이 없습니다.</div>
        )}
      </div>
    </>
  );
}
